import React from 'react'
import styled, {
  elementProps,
  labelWhenSmallProps,
} from '../../constants/theme'
import { FormElementProps } from './FormElementParts'

const INITIAL_HEIGHT = 34 // matches height of InputElement

interface State {
  height: number
  value: string
}

class TextareaElement extends React.Component<FormElementProps, State> {
  state = { height: INITIAL_HEIGHT, value: this.props.value || '' }

  componentDidUpdate(prevProps) {
    if (
      (this.props.value || this.props.value === '') &&
      prevProps.value !== this.props.value
    ) {
      this.setState({ value: this.props.value })
    }
  }

  handleChange = e => {
    e.preventDefault()

    const { onChange, name } = this.props
    const newValue = e.target.value

    e.persist() // need this to recalculate the height async
    this.setState({ height: INITIAL_HEIGHT, value: newValue }, () => {
      this.setState({ height: e.target.scrollHeight })
    })

    if (onChange) {
      onChange({ name, value: newValue })
    }
  }

  handleBlur = () => {
    this.setState({ value: this.state.value })
  }

  setInitialHeight = comp => {
    if (comp) {
      this.setState({ height: comp.scrollHeight })
    }
  }

  render() {
    const {
      disabled,
      isFocused,
      isRequired,
      name,
      onInput,
      onKeyUp,
      onPaste,
      placeholder,
      unifiedErrorText,
    } = this.props

    const { height, value } = this.state
    const className = value.length > 0 ? 'HasValue' : ''
    if (!name) {
      return null
    }
    const isInvalid = !!(unifiedErrorText && unifiedErrorText.length > 0)
    /* eslint-disable */
    return (
      <Textarea
        aria-describedby={isInvalid ? `${name}Error` : undefined}
        aria-invalid={isInvalid}
        autoFocus={isFocused}
        className={className}
        disabled={disabled}
        height={height}
        id={name}
        name={name}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        onInput={onInput}
        onKeyUp={onKeyUp}
        onPaste={onPaste}
        placeholder={placeholder || undefined}
        ref={this.setInitialHeight}
        required={isRequired}
        value={value}
      />
    )
    /* eslint-enable */
  }
}

const Textarea = styled.textarea<{ height: number }>(
  {
    '&:disabled': {
      cursor: 'not-allowed',
    },
    '&:focus ~ label, &:disabled ~ label, &.HasValue ~ label': {
      ...labelWhenSmallProps,
    },
    ...elementProps,
    boxShadow: 'unset', // kills red around 'required' inputs in FF
    lineHeight: 1.3,
    paddingBottom: 0,
    resize: 'none',
  },
  ({ height, theme }) => ({
    '.invalid &': {
      color: theme.error,
      fontWeight: 'bold',
    },
    color: theme.text,
    fontFamily: theme.fontFamily,
    height,
  }),
)
Textarea.displayName = 'Textarea'

export default TextareaElement
